<template lang="html">
  <div class="fsd-video__youtube">
    <template v-if="consentGoogle === 'GRANTED'">
      <iframe
        :src="youtubeVideo"
        class="fsd-video__youtube-iframe"
        :title="title"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      />
    </template>
    <template v-else-if="consentGoogle === 'DENIED'">
      <div class="widgets-missing-consent">
        <p class="widgets-social_feed__notice">
          {{ 'client.consent.hints.youtube' | t }}
        </p>
        <button
          type="button"
          class="button button--secondary button--small widgets-social_feed__button"
          @click="onRequestConsent"
        >
          {{ 'client.consent.optin' | t }}
        </button>
        <!-- eslint-disable vue/no-v-html -->
        <p
          class="widgets-social_feed__notice widgets-social_feed__notice--small"
          v-html="$options.filters.t('client.consent.notice_html')"
        />
        <!-- eslint-enable vue/no-v-html -->
      </div>
    </template>
  </div>
</template>

<script>
import { requestConsent } from '@/util/consent'
import { mapState } from 'vuex'

export default {
  props: {
    youtubeVideo: { type: String, required: true },
    meta: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data: () => {
    return {
      visible: false,
      consentGoogle: null,
      consentRequested: false
    }
  },
  computed: {
    ...mapState(['consent']),
    icon() {
      return this.visible ? 'chevron-up' : 'chevron-down'
    },
    title() {
      if (this.meta && this.meta.employer) {
        return `${this.meta.employer} - Youtube Video`
      } else {
        return 'Youtube Video'
      }
    }
  },
  watch: {
    'consent.google': function (newConsent, oldConsent) {
      // trigger toggleYoutubeVideo() for users who requestedConsent (probably) via onRequestConsent()
      if (
        oldConsent === 'DENIED' &&
        newConsent === 'GRANTED' &&
        this.consentRequested
      ) {
        this.consentRequested = false
        this.toggleYoutubeVideo()
      }
      // reset component if consent gets removed on an initialized map
      if (newConsent === 'DENIED') {
        this.visible = false
        this.consentRequested = false
      }
      this.consentGoogle = newConsent
    }
  },
  mounted() {
    this.consentGoogle = this.consent.google
  },
  methods: {
    onRequestConsent() {
      this.consentRequested = true
      requestConsent()
    },
    toggleYoutubeVideo() {
      this.visible = !this.visible
    }
  }
}
</script>

<style lang="css" scoped></style>
